{% block swag_cms_extensions_form_editor_settings_field_type_base %}
    <div class="swag-cms-extensions-form-editor-settings-field-type-select">
        {% block swag_cms_extensions_form_editor_settings_field_type_select_mode %}
            <sw-single-select
                v-model:value="mode"
                :options="modes"
                size="medium"
                :label="$tc('swag-cms-extensions.sw-cms.components.form-editor.settings-field.modeFieldLabel')"
                required
                @update:value="onModeChange"
            ></sw-single-select>
        {% endblock %}

        {% block swag_cms_extensions_form_editor_settings_field_type_select_entity %}
            <sw-single-select
                v-if="mode === 'entity'"
                v-model:value="entity"
                :options="availableEntities"
                :label="$tc('swag-cms-extensions.sw-cms.components.form-editor.settings-field.entityFieldLabel')"
                size="medium"
                required
            ></sw-single-select>
        {% endblock %}

        {% block swag_cms_extensions_form_editor_settings_field_type_select_options %}
            <sw-tagged-field
                v-else
                v-model:value="options"
                :label="$tc('swag-cms-extensions.sw-cms.components.form-editor.settings-field.optionsFieldLabel')"
                :error="fieldConfigOptionsError"
                size="medium"
                required
                @change="onCustomOptionsChange"
            ></sw-tagged-field>
        {% endblock %}

        {% block swag_cms_extensions_form_editor_settings_field_type_select_placeholder %}
            <mt-text-field
                v-model="placeholder"
                :label="$tc('swag-cms-extensions.sw-cms.components.form-editor.settings-field.placeholderFieldLabel')"
                size="medium"
            />
        {% endblock %}
    </div>
{% endblock %}
